export default __webpack_public_path__ + "static/AMA20 Finalist Medal_Broker of the Year - Independent-9c3a7c99787716cc56daa76dddb47751.png";